import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["id"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", {
    id: $props.id,
    style: _normalizeStyle($options.getComputedStyle),
    class: _normalizeClass($props.classes)
  }, [_renderSlot(_ctx.$slots, "default")], 14, _hoisted_1);
}